<template>
    <div class="guided">
        <Title :title="'Visitas guiadas'"></Title>
        <div class="row middle-xs content">
            <div class="col-md-1 col-lg-3"></div>
            <div class="col-sm-6 col-md-5 col-lg-3 mobile-padded__evenly mobile-center" v-if="loaded">
                <div>
                    <p v-for="paragraph in entry.fields.body.content" :key="paragraph.content[0].value">
                        {{paragraph.content[0].value}}
                    </p>
                </div>
                <div class="row">
                    <div class="col-xs-12 know-more">
                        <button v-on:click="guidedTours()">Saiba Mais</button>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6" v-if="loaded">
                <div class="image-wrapper">
                    <img class="guided-img" :src="entry.fields.image.fields.file.url" :alt="entry.fields.image.fields.description" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "../generic/Title";
    import contentHelper from "../../helpers/content.helper";

    export default {
        name: "GuidedTours",
        components: {Title},
        data() {
            return {
                entry: null,
                loaded: false
            }
        },
        mounted() {
            contentHelper.client
                .getEntry("1mBMEOfapywQL3nCsNRodG")
                .then(entry => {
                    this.entry = entry.toPlainObject();
                    this.loaded = true;
                })
                .catch(err => console.log(err));
        },
        methods: {
            guidedTours() {
                this.$router.push(`/guided-tours`).catch(() => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .guided {
        margin-bottom: 3em;
        height: 100%;
        text-align: left;

        .row {
            height: 100%;
        }
    }

    .image-wrapper {
        margin-right: -7em;
        height: 100%;
        min-height: 30em;
    }

    .guided-img {
        height: 100%;
        object-fit: cover;
        object-position: center;
        margin-bottom: -0.27em;
    }

    @media only screen and (max-width: 767px) {
        .guided-img {
            width: 100%;
        }
        .image-wrapper {
            min-height: 0em;
        }
    }

    h1 {
        color: $bgcolor;
    }

    p {
        font-family: "Merriweather", serif;
        line-height: 1.5em;
        color: $bgcolor-grey;
        font-size: 1em;
        font-weight: 400;
        font-style: italic;
    }

    .content {
        background-color: $primary;
    }

    .know-more {
        margin-top: 2em;
        margin-bottom: 1em;

        padding-right: 0;
        padding-left: 0;
        button {
            height: 3.5em;
            border: 0;
            width: 100%;
            background: $bgcolor-grey;
            color: $primary;
            text-transform: uppercase;
            font-size: x-small;
            letter-spacing: 0.1em;
            font-weight: 600;

            padding-right: 0;
            padding-left: 0;

            &:hover {
                background: $primary;
                color: $bgcolor-grey;
                border-color: $bgcolor-grey;
                border-width: thin;
                border-style: solid;
            }
        }
    }
</style>
